"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _commonI18n = require("@mmc/common-i18n");

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _reactScroll = require("react-scroll");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;

var renderH2Headline = function renderH2Headline(params) {
  var _styles = params._styles,
      _theme = params._theme,
      columnCounter = params.columnCounter,
      headlineString = params.headlineString;
  return /*#__PURE__*/_react["default"].createElement("thead", {
    className: _styles.tableHeaderContainer
  }, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
    colSpan: "" + columnCounter,
    className: _styles.mainHeadline
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: _theme.headingTwo
  }, headlineString))));
};

var keyFeaturePrice = function keyFeaturePrice(params) {
  var _params$price = params.price,
      value = _params$price.value,
      displayValue = _params$price.displayValue,
      zeroMessage = _params$price.zeroMessage,
      config = params.config,
      _styles = params._styles;
  return /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _styles.tableDataInner
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
    format: "price",
    options: {
      value: value,
      currency: handleNestedProp(config, 'config.currencyFormat'),
      locale: handleNestedProp(config, 'config.localeCode'),
      displayValue: displayValue,
      zeroMessage: zeroMessage
    }
  }))));
};

var keyFeatureCheck = function keyFeatureCheck(_styles, _theme, spec) {
  return /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _styles.tableDataInner + " " + (spec.availablility === 'NotAvailable' ? _theme.mmcIconClose + " " + _styles.dataXmark : _styles.dataCheckmark)
  }));
};

var regularFeatureCheck = function regularFeatureCheck(params) {
  var _styles = params._styles,
      _theme = params._theme,
      selectedObject = params.selectedObject,
      specIndex = params.specIndex;
  return /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _styles.tableDataInner + " " + (selectedObject.specs[specIndex].label === '' ? _theme.mmcIconDash + " " + _styles.dataDash : _styles.dataCheckmark)
  }));
};

var regularFeatureFiller = function regularFeatureFiller(_styles) {
  return /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _styles.tableDataInner
  }));
};

var renderKeyFeatures = function renderKeyFeatures(params) {
  var _tables = params._tables,
      config = params.config,
      _styles = params._styles,
      _theme = params._theme,
      columnCounter = params.columnCounter,
      columnLimit = params.columnLimit;
  return /*#__PURE__*/_react["default"].createElement("tbody", null, _tables.keyFeatures.specs.map(function (spec) {
    var tdHeaderRow = null;
    var tdArray = []; // If the spec is unavaible of all selected components, do not render the row

    var emptyRow = true;

    for (var i = 0; i < columnLimit; i += 1) {
      if (emptyRow && (spec[i] ? spec[i].availablility === 'NotAvailable' : true)) {// emptyRow = true;
      } else {
        emptyRow = false;
        break;
      }
    }

    if (emptyRow) return ''; // Add row into the table

    if (spec[0]) {
      tdHeaderRow = /*#__PURE__*/_react["default"].createElement("th", {
        scope: "row",
        colSpan: "" + columnCounter,
        className: _styles.tableDataHeader + " " + _styles.featureHeadline + " " + _styles.newSpec
      }, spec[0].label);
    }

    for (var _i = 0; _i < columnLimit; _i += 1) {
      var price = handleNestedProp(_tables, "_tables.keyFeatures.models." + _i + ".price");

      if (spec[_i] && spec[_i].titleAndText && price !== ' ') {
        // Do not return a price table row if zero price is found
        var hasZeroMessage = typeof price.zeroMessage === 'string' && price.zeroMessage.length > 1;

        if (price === ' ' || price.value <= 0 && !hasZeroMessage) {
          return '';
        }

        tdArray.push(keyFeaturePrice({
          price: price,
          config: config,
          _styles: _styles,
          index: _i
        }));
      } else if (spec[_i]) {
        tdArray.push(keyFeatureCheck(_styles, _theme, spec[_i]));
      }
    }

    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: spec[0].label
    }, /*#__PURE__*/_react["default"].createElement("tr", {
      className: _styles.tableDataRow
    }, tdHeaderRow), /*#__PURE__*/_react["default"].createElement("tr", {
      className: _styles.tableDataRow
    }, tdArray));
  }));
};

var getHitCount = function getHitCount(selectedModels, specIndex, columnLimit) {
  var hitCount = 0;

  for (var i = 0; i < columnLimit; i += 1) {
    if (selectedModels[i] && selectedModels[i].specs[specIndex] ? selectedModels[i].specs[specIndex].label === '' : true) {
      hitCount += 1;
    }
  }

  return hitCount;
};

var getTableArray = function getTableArray(params) {
  var selectedModels = params.selectedModels,
      _styles = params._styles,
      _theme = params._theme,
      specIndex = params.specIndex,
      columnLimit = params.columnLimit;
  var tdFeatureRowLabel = '';
  var tdArray = []; // Add row into the table with n columns

  for (var i = 0; i < columnLimit; i += 1) {
    if (selectedModels[i] && selectedModels[i].specs[specIndex]) {
      if (tdFeatureRowLabel === '' && selectedModels[i].specs[specIndex].label !== '') {
        tdFeatureRowLabel = selectedModels[i].specs[specIndex].label;
      }

      tdArray.push(regularFeatureCheck({
        _styles: _styles,
        _theme: _theme,
        selectedObject: selectedModels[i],
        specIndex: specIndex
      }));
    } else if (selectedModels[i]) {
      tdArray.push(regularFeatureFiller(_styles));
    }
  }

  return {
    tdArray: tdArray,
    tdFeatureRowLabel: tdFeatureRowLabel
  };
};

var renderAllFeatures = function renderAllFeatures(params) {
  var group = params.group,
      _styles = params._styles,
      _theme = params._theme,
      columnCounter = params.columnCounter,
      columnLimit = params.columnLimit;
  return /*#__PURE__*/_react["default"].createElement("tbody", null, group.map(function (sub) {
    return [sub.selectedModels.map(function (selectedModel, selectedModelIndex) {
      var previousHeader = '';

      if (selectedModelIndex === 0) {
        return selectedModel.specs.map(function (spec, specIndex) {
          var tdHeaderRow = null;
          var tdFeatureRow = '';
          var tdData = getTableArray({
            selectedModels: sub.selectedModels,
            _styles: _styles,
            _theme: _theme,
            specIndex: specIndex,
            tdFeatureRow: tdFeatureRow,
            columnLimit: columnLimit
          }); // If the spec is unavailable of all selected components, do not render the row

          var hitCount = getHitCount(sub.selectedModels, specIndex, columnLimit);
          if (hitCount === columnLimit) return ''; // Category title

          if (sub.selectedModels[0]) {
            if (previousHeader !== sub.categoryTitle && group.length > 1) {
              tdHeaderRow = /*#__PURE__*/_react["default"].createElement("tr", {
                className: _styles.tableDataRow
              }, /*#__PURE__*/_react["default"].createElement("th", {
                scope: "row",
                colSpan: "" + columnCounter,
                className: _theme.headingFour + " " + _styles.tableDataHeader + " " + _styles.sectionHeadline + " " + _styles.newSpec
              }, sub.categoryTitle));
              previousHeader = sub.categoryTitle;
            } else {
              tdHeaderRow = null;
            }
          } // Feature name


          if (tdData.tdFeatureRowLabel && tdData.tdFeatureRowLabel !== '') {
            tdFeatureRow = /*#__PURE__*/_react["default"].createElement("tr", {
              className: _styles.tableDataRow
            }, /*#__PURE__*/_react["default"].createElement("th", {
              scope: "row",
              colSpan: "" + columnCounter,
              className: _styles.tableDataHeader + " " + _styles.featureHeadline + " " + _styles.newSpec
            }, tdData.tdFeatureRowLabel));
          }

          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, tdHeaderRow, tdFeatureRow, /*#__PURE__*/_react["default"].createElement("tr", {
            className: _styles.tableDataRow
          }, tdData.tdArray));
        });
      }

      return null;
    })];
  }));
};

var renderComparisonTable = function renderComparisonTable(params) {
  var _tables = params._tables,
      _styles = params._styles,
      _theme = params._theme,
      _numberOfColumns = params._numberOfColumns,
      config = params.config,
      _tabs = params._tabs,
      _scrollTabs = params._scrollTabs; // tracking bits

  var headlineIndex = 0;
  var columnLimit = _numberOfColumns;
  var columnCounter = 0;

  if (_tables.keyFeatures) {
    columnCounter = _tables.keyFeatures.models.length;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _styles.tableOuter
  }, _tables.keyFeatures && /*#__PURE__*/_react["default"].createElement(_reactScroll.Element, {
    name: _scrollTabs[headlineIndex]
  }, /*#__PURE__*/_react["default"].createElement("table", {
    className: _styles.tableCompare
  }, renderH2Headline({
    _styles: _styles,
    _theme: _theme,
    columnCounter: columnCounter,
    headlineString: _tabs[headlineIndex]
  }), renderKeyFeatures({
    _tables: _tables,
    config: config,
    _styles: _styles,
    _theme: _theme,
    columnCounter: columnCounter,
    columnLimit: columnLimit
  }))), _tables.allOtherFeatures.map(function (group) {
    headlineIndex += 1;
    return /*#__PURE__*/_react["default"].createElement(_reactScroll.Element, {
      name: _scrollTabs[headlineIndex]
    }, /*#__PURE__*/_react["default"].createElement("table", {
      className: _styles.tableCompare
    }, renderH2Headline({
      _styles: _styles,
      _theme: _theme,
      columnCounter: columnCounter,
      headlineString: _tabs[headlineIndex]
    }), renderAllFeatures({
      group: group,
      _styles: _styles,
      _theme: _theme,
      columnCounter: columnCounter,
      columnLimit: columnLimit
    })));
  }));
};

var _default = renderComparisonTable;
exports["default"] = _default;